// Scroll Event Handling

// Cache the progress bar element to avoid repeated DOM lookups
var progressBar = document.querySelector('.multiple-progress-bar');

// Use requestAnimationFrame to optimize scroll handling
var isScrolling = false;
var isActivated = false;

var handleScroll = () => {
  // Check if the progress bar is already activated
  if (isActivated) return;

  var scrollPosition = window.scrollY;
  var elementTop = progressBar.getBoundingClientRect().top + window.innerHeight;

  if (scrollPosition > elementTop) {
    progressBar.classList.add('progressbar-active');
    isActivated = true; // Set flag to true to prevent re-triggering
    window.removeEventListener('scroll', onScroll); // Remove scroll event listener
  }

  isScrolling = false;
};

var onScroll = () => {
  if (!isScrolling) {
    requestAnimationFrame(handleScroll);
    isScrolling = true;
  }
};

window.addEventListener('scroll', onScroll, { passive: true });


// Tooltip Handling for Accessibility
document.addEventListener('DOMContentLoaded', () => {
    // Select all tooltips and tooltip open buttons
    var tooltipPopups = document.querySelectorAll('.main-tooltip-popup');
    var tooltipButtons = document.querySelectorAll('.tooltip-btn');

    // Function to open the tooltip and set focus
    var openTooltip = (tooltip) => {
        tooltip.classList.add('active');
        tooltip.setAttribute('aria-hidden', 'false');
        tooltip.querySelector('.tooltip-close-btn').focus();
    };

    // Function to close the tooltip and remove focus
    var closeTooltip = (tooltip) => {
        tooltip.classList.remove('active');
        tooltip.setAttribute('aria-hidden', 'true');
    };

    // Event listener to open tooltip on tooltip button click
    tooltipButtons.forEach(button => {
        button.addEventListener('click', (event) => {
            var leftHeading = event.target.closest('.left-heading');
            if (leftHeading) {
                var tooltip = leftHeading.querySelector('.main-tooltip-popup');
                // Close any active tooltip before opening a new one
                document.querySelectorAll('.main-tooltip-popup.active').forEach(popup => closeTooltip(popup));
                openTooltip(tooltip);
            }
        });
    });

    // Event listener to close tooltip on close button click
    tooltipPopups.forEach(popup => {
        var closeButton = popup.querySelector('.tooltip-close-btn');
        closeButton.addEventListener('click', () => closeTooltip(popup));
    });

    // Close tooltip when the Escape key is pressed
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            document.querySelectorAll('.main-tooltip-popup.active').forEach(popup => closeTooltip(popup));
        }
    });

    // Close tooltip when clicking outside of tooltip content
    document.addEventListener('click', (event) => {
        var isTooltipContent = event.target.closest('.flex-popup-content');
        var isTooltipButton = event.target.closest('.tooltip-btn');
        
        // If click is outside tooltip or button, close any active tooltip
        if (!isTooltipContent && !isTooltipButton) {
            document.querySelectorAll('.main-tooltip-popup.active').forEach(popup => closeTooltip(popup));
        }
    });
});
